import { render } from "./DigitalMarketing.vue?vue&type=template&id=7d3bfc50&scoped=true"
import script from "./DigitalMarketing.vue?vue&type=script&lang=js"
export * from "./DigitalMarketing.vue?vue&type=script&lang=js"

import "./DigitalMarketing.vue?vue&type=style&index=0&id=7d3bfc50&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3bfc50"]])

export default __exports__